import { commonFilter } from './filter';

export default {
  pageName: 'ByChannel-Overview',
  pageId: '20105',
  pagePath: '/opinion/Accounts/ByChannel',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
